var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSolidChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55802 9.44194L9.55802 12.4419C9.80209 12.686 10.1978 12.686 10.4419 12.4419L13.4419 9.44194C13.6206 9.26319 13.6741 8.99437 13.5774 8.76082C13.4806 8.52728 13.2527 8.375 13 8.375H6.99996C6.74717 8.375 6.51927 8.52728 6.42253 8.76082C6.32579 8.99437 6.37927 9.26319 6.55802 9.44194Z",
    fill: "white",
    fillOpacity: 0.61
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSolidChevronDown);
export default __webpack_public_path__ + "static/media/arrow-solid-chevron-down.9ebdeb018659576f5851752500f633df.svg";
export { ForwardRef as ReactComponent };